import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { FormattedMessage } from "react-intl";

import { ChatWithITSupportFlyoutLink } from "@/components/GetSupport";
import {
  Day1EventAction,
  Day1EventCategory,
  Day1EventLabel,
} from "@/types/snowplow-events";

type ITChatVerificationGuidanceProps = {
  /*** The Snowplow event category ***/
  eventCategory:
    | Day1EventCategory.IDVPrefSelect
    | Day1EventCategory.IDCheckFull
    | Day1EventCategory.IDCheckLight;
};

/**
 * Display the information about completing IDV via Chime with an ITSE.
 * @constructor
 */
export default function ITChatVerificationGuidance({
  eventCategory,
}: ITChatVerificationGuidanceProps): JSX.Element {
  return (
    <Col gridGap="S200" dataTestId="chimeIdvGuidance">
      <Text
        dataTestId="idvPathChooserAddtionalConcern"
        fontSize="T200"
        fontWeight="medium"
      >
        <FormattedMessage id="identityCheck-pathchooser-additionalConcerns" />
      </Text>
      <Text dataTestId="idvPathChooserContactIt" fontSize="T100">
        <FormattedMessage
          id="identityCheck-pathchooser-additionalConcerns-contactIt"
          values={{
            chatWithITSupportLink: (
              <ChatWithITSupportFlyoutLink
                localeMessageId="text-chatWithITSupport"
                fontSize="T100"
                reason="verificationWithChime"
                metricProps={{
                  category: eventCategory,
                  action: Day1EventAction.ChatWithSupport,
                  label: Day1EventLabel.IDVerificationChime,
                }}
              />
            ),
          }}
        />
      </Text>
    </Col>
  );
}
